import React from "react";
import { Link } from "react-router";
import type { IncidentVm } from "@/features/daily/components/command/command-view-model";
import { IncidentActions } from "@/features/daily/components/incidents/IncidentActions";
import type { IncidentAction } from "@/features/daily/components/incidents/incident-command";

type Props = {
    incident: IncidentVm;
    pendingAction: IncidentAction | null;
    error: string | null;
    onAct: (action: IncidentAction) => void;
};

export const IncidentCard: React.FC<Props> = ({ incident, pendingAction, error, onAct }) => (
    <li>
        <article className="daily-incident" data-tone={incident.tone} aria-label={`Incidencia: ${incident.title}`}>
            <div className="daily-actions">
                {/* Severity and lifecycle are words, not just a colour (WCAG 1.4.1). */}
                <span className="daily-pill" data-tone={incident.tone}>
                    {incident.severityLabel} · {incident.scopeLabel}
                </span>
                <span className="daily-pill">{incident.lifecycleLabel} · Episodio {incident.episode}</span>
            </div>
            <h3 className="daily-incident__title">{incident.title}</h3>
            <p className="daily-incident__meta">
                Visto primero {incident.firstObservedLabel} · Última observación {incident.lastObservedLabel}
                <br />
                Responsable: {incident.ownerLabel} · {incident.acknowledgementLabel} · {incident.policyLabel}
            </p>
            {incident.reasons.length > 0 ? (
                <ul className="daily-reasons">
                    {incident.reasons.map((reason) => <li key={reason}>{reason}</li>)}
                </ul>
            ) : null}
            <nav className="daily-actions" aria-label={`Evidencia de ${incident.title}`}>
                <Link className="daily-button" to={incident.queueHref}>Ver operaciones afectadas</Link>
                <Link className="daily-link" to={incident.evidenceHref}>Ver la evidencia</Link>
            </nav>
            {error !== null ? <p className="daily-incident__error" role="alert">{error}</p> : null}
            {/* SC-011: without the operator role the buttons are absent, not disabled. */}
            {incident.actionsVisible
                ? <IncidentActions incident={incident} pendingAction={pendingAction} onAct={onAct} />
                : null}
        </article>
    </li>
);
